import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PurchaseInfoComponent } from './purchase-info.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AlertModule } from '../alert/alert.module';
import { HeroModule } from '../hero/hero.module';
import { TimerFormatterModule } from '../timer-formatter/timer-formatter.module';
import { InfoMessageModule } from '../info-message/info-message.module';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    AlertModule,
    HeroModule,
    
    TimerFormatterModule,
    InfoMessageModule
  ],
  exports: [
    PurchaseInfoComponent
  ],
  providers: [
  ],
  declarations: [
    PurchaseInfoComponent
  ]
})
export class PurchaseInfoModule { }
